import type { SemVer } from "semver";
import semver from "semver";
import type { DocMigration, DocMigrationInstance } from "./docMigration";

export function schemaVersionCompare(a: string, op: "==" | ">" | ">=" | "<" | "<=", b: string) {
  switch (op) {
    case "==":
      return semver.eq(a, b);
    case ">":
      return semver.gt(a, b);
    case ">=":
      return semver.gte(a, b);
    case "<":
      return semver.lt(a, b);
    case "<=":
      return semver.lte(a, b);
  }
}

export function resolveDocMigrations(migrations: DocMigration[]): DocMigrationInstance[] {
  const list: DocMigrationInstance[] = [];
  let lastVersionString = "";
  let lastVersion: SemVer | null = null;

  for (const migration of migrations) {
    // Legacy migrations had explicit versions
    if (migration.maxSchemaVersion) {
      lastVersionString = migration.maxSchemaVersion;
      lastVersion = null;

      list.push({
        id: `v${migration.maxSchemaVersion.replaceAll(".", "_")}`,
        description: "",
        maxSchemaVersion: "",
        ...migration,
      });
    }

    // While new migrations have the version automatically derived and incremented
    else {
      if (!lastVersion) {
        lastVersion = semver.parse(lastVersionString);
      }

      if (!lastVersion) {
        throw new Error(`Invalid schema version ${lastVersionString}, unable to increment patch number.`);
      }

      lastVersion.inc("patch");
      const maxSchemaVersion = lastVersion.toString();

      list.push({
        id: `migration_${migration.maxSchemaVersion}`,
        description: "",
        maxSchemaVersion,
        ...migration,
      });
    }
  }

  return list;
}

export function getNextSchemaVersion(migrations: DocMigrationInstance[]): string {
  return semver.inc(migrations[migrations.length - 1].maxSchemaVersion, "patch") as string;
}
